import { ExternalLink } from "lucide-react";

export default function SponsorBanner({ sponsor, variant = "banner" }) {
  if (!sponsor || !sponsor.name) return null;

  if (variant === "footer") {
    return (
      <div className="text-center text-xs text-slate-500 mt-4 pt-3 border-t border-slate-800" data-testid="sponsor-footer">
        This Match Day was sponsored by{" "}
        {sponsor.link ? (
          <a href={sponsor.link} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
            {sponsor.name}
          </a>
        ) : (
          <span className="text-slate-400">{sponsor.name}</span>
        )}
      </div>
    );
  }

  if (variant === "header") {
    return (
      <span className="flex items-center gap-1 text-slate-500 text-xs" data-testid="sponsor-header">
        {" Sponsored by "}
        {sponsor.logo_url && (
          <img src={sponsor.logo_url} alt={sponsor.name} className="h-4 max-w-[50px] object-contain" />
        )}
        {sponsor.link ? (
          <a href={sponsor.link} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white flex items-center gap-0.5">
            {sponsor.name} <ExternalLink className="w-3 h-3" />
          </a>
        ) : (
          <span className="text-slate-400">{sponsor.name}</span>
        )}
      </span>
    );
  }

  // Default banner - redesigned with proper order: Sponsored by > Logo and link > Description
  return (
    <div className="bg-slate-800/40 border border-slate-700/30 rounded-lg px-4 py-3 text-center" data-testid="sponsor-banner">
      {/* Sponsored by label */}
      <p className="text-slate-400 text-sm mb-2">Sponsored by</p>
      
      {/* Logo and Name - larger font */}
      <div className="flex items-center justify-center gap-2 mb-2">
        {sponsor.logo_url && (
          <img src={sponsor.logo_url} alt={sponsor.name} className="h-7 max-w-[80px] object-contain" />
        )}
        {sponsor.link ? (
          <a 
            href={sponsor.link} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-white hover:text-emerald-400 font-semibold text-base flex items-center gap-1 transition-colors"
          >
            {sponsor.name} <ExternalLink className="w-4 h-4" />
          </a>
        ) : (
          <span className="text-white font-semibold text-base">{sponsor.name}</span>
        )}
      </div>
      
      {/* Optional description - max 2 lines */}
      {sponsor.description && (
        <p className="text-slate-400 text-xs leading-relaxed line-clamp-2 max-w-xs mx-auto">
          {sponsor.description}
        </p>
      )}
    </div>
  );
}
